/*
 * Copyright (c) 2024-2026. The content provided herein is protected by copyright law. Unauthorized use, reproduction, or distribution of this material without proper licensing, knowledge, and contract agreement from the author is strictly prohibited. Any infringement of these rights may result in legal action. For inquiries regarding the use of this content, please contact the author for proper authorization and agreement.
 */
import React from 'react'
import { Offer } from 'types/entities/Offer'
import EditCompanyModalOfferItem from './EditCompanyModalOfferItem'

interface EditCompanyModalOfferListProps {
    offers: Offer[]
    onClick: (offer: Offer) => void
}

const EditCompanyModalOfferList = (props: EditCompanyModalOfferListProps) => {
    if (!props.offers.length) {
        return null
    }

    return (
        <>
            {props.offers.map((offer) => (
                <EditCompanyModalOfferItem
                    key={`${offer.id}`}
                    offer={offer}
                    onClick={props.onClick}
                />
            ))}
        </>
    )
}

export default EditCompanyModalOfferList
